/**
 * GdIcons — самодельные SVG-иконки для меню/правил/уровней GD.
 * Цвета по умолчанию используют currentColor — задавай через style/color.
 */
import React from 'react';

const sz = (size, color, vb = '0 0 24 24') => ({
    width: size, height: size, viewBox: vb,
    fill: color || 'currentColor',
    xmlns: 'http://www.w3.org/2000/svg',
    style: { display: 'inline-block', verticalAlign: 'middle' },
});

export const IconGamepad = ({ size = 28, color }) => (
    <svg {...sz(size, color)}>
        <path d="M6 8c-2.2 0-4 1.8-4 4v3c0 1.7 1.3 3 3 3 .9 0 1.7-.4 2.2-1l2-2h5.5l2 2c.6.6 1.4 1 2.3 1 1.7 0 3-1.3 3-3v-3c0-2.2-1.8-4-4-4H6zm-1 4h2v2H5v-2zm12 1c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1zm-2-2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z" />
    </svg>
);

export const IconStar = ({ size = 24, color = '#ffe44a', outline }) => (
    <svg {...sz(size, outline ? 'none' : color)}>
        <path
            d="M12 2l2.9 6.6 7.1.7-5.3 4.8L18.2 22 12 18.3 5.8 22l1.5-7.9L2 9.3l7.1-.7L12 2z"
            stroke={outline ? color : 'none'}
            strokeWidth={outline ? 2 : 0}
            strokeLinejoin="round"
        />
    </svg>
);

export const IconShop = ({ size = 24, color }) => (
    <svg {...sz(size, color)}>
        <path d="M3 6h18l-1.5 9c-.2 1.2-1.2 2-2.4 2H6.9c-1.2 0-2.2-.8-2.4-2L3 6zm-1-3h2.2l.6 2H22v2H4.3L3.7 5H2V3zm6 17c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 0c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" />
    </svg>
);

export const IconBook = ({ size = 24, color }) => (
    <svg {...sz(size, color)}>
        <path d="M4 4v16c1.5-1 3.5-1.5 6-1.5s4.5.5 6 1.5V4c-1.5-1-3.5-1.5-6-1.5S5.5 3 4 4zm14 0v16c1.5-1 3.5-1.5 6-1.5V2.5c-2.5 0-4.5.5-6 1.5z" transform="translate(-2 0)" />
    </svg>
);

export const IconSettings = ({ size = 22, color }) => (
    <svg {...sz(size, color)}>
        <path d="M19.4 13.2l1.7-1.4c.2-.2.3-.4.2-.7L19.4 8c-.1-.2-.3-.3-.6-.3l-2.2.5c-.5-.4-1-.7-1.6-1l-.3-2.3c0-.2-.2-.4-.5-.4h-3.6c-.3 0-.4.2-.5.4l-.3 2.3c-.6.3-1.1.6-1.6 1l-2.2-.5c-.3 0-.5.1-.6.3L3.7 11.1c-.1.3 0 .5.2.7L5.6 13.2c0 .3-.1.5-.1.8s0 .5.1.8L3.7 16.2c-.2.2-.3.4-.2.7L5.4 20c.1.2.3.3.6.3l2.2-.5c.5.4 1 .7 1.6 1l.3 2.3c.1.2.2.4.5.4h3.6c.3 0 .5-.2.5-.4l.3-2.3c.6-.3 1.1-.6 1.6-1l2.2.5c.3 0 .5-.1.6-.3l1.9-3.1c.1-.3 0-.5-.2-.7l-1.7-1.4c0-.3.1-.5.1-.8s-.1-.5-.1-.8zM12 16c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3z" />
    </svg>
);

export const IconArrowLeft = ({ size = 20, color }) => (
    <svg {...sz(size, color)}>
        <path d="M14 7l-5 5 5 5V7z" />
    </svg>
);

export const IconArrowRight = ({ size = 20, color }) => (
    <svg {...sz(size, color)}>
        <path d="M10 17l5-5-5-5v10z" />
    </svg>
);

export const IconReplay = ({ size = 20, color }) => (
    <svg {...sz(size, color)}>
        <path d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8z" />
    </svg>
);

export const IconLock = ({ size = 44, color }) => (
    <svg {...sz(size, color)}>
        <path d="M12 2C9.2 2 7 4.2 7 7v3H6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2h-1V7c0-2.8-2.2-5-5-5zm0 2c1.7 0 3 1.3 3 3v3H9V7c0-1.7 1.3-3 3-3zm0 11c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" />
    </svg>
);

export const IconBoss = ({ size = 22, color = '#ff5566' }) => (
    <svg {...sz(size, color)}>
        <path d="M5 16l1-9 3 4 3-6 3 6 3-4 1 9c0 1-1 2-2 2H7c-1 0-2-1-2-2zm3 2v1c0 .5.5 1 1 1h6c.5 0 1-.5 1-1v-1H8z" />
    </svg>
);

export const IconPlay = ({ size = 20, color }) => (
    <svg {...sz(size, color)}>
        <path d="M7 5v14l11-7L7 5z" />
    </svg>
);

export const IconTree = ({ size = 26, color = '#22ff66' }) => (
    <svg {...sz(size, color)}>
        <path d="M12 2l-5 7h2.5L5 14h3l-3 4h6v3h2v-3h6l-3-4h3l-4.5-5H17l-5-7z" />
    </svg>
);

export const IconMountain = ({ size = 26, color = '#88ccff' }) => (
    <svg {...sz(size, color)}>
        <path d="M14 6l-3 5-2-3-7 11h22l-10-13zm0 3l3 4-2 2 1 2h-9l4-6 1.5 2L14 9z" />
    </svg>
);

export const IconDiamond = ({ size = 22, color = '#44ccff' }) => (
    <svg {...sz(size, color)}>
        <path d="M6 3l-4 6 10 12 10-12-4-6H6zm.5 2h11l2.5 4-8 9.5L4 9l2.5-4zm2 0L7 9h10l-1.5-4h-7z" />
    </svg>
);

export const IconCoin = ({ size = 22, color = '#ffe44a' }) => (
    <svg {...sz(size, color)}>
        <circle cx="12" cy="12" r="10" />
        <text x="12" y="16" textAnchor="middle" fontSize="11" fontWeight="800" fill="#0a1428" fontFamily="sans-serif">$</text>
    </svg>
);

export const IconFinish = ({ size = 26, color }) => (
    <svg {...sz(size, color)}>
        <path d="M5 3v18h2V14c2 0 2.5 1 5 1s4-2 8-2V4c-4 0-5 2-8 2s-3-1-5-1V3H5z" />
    </svg>
);

export const IconPortal = ({ size = 22, color = '#ff8833' }) => (
    <svg {...sz(size, color)}>
        <path d="M12 2C7 2 3 6 3 11v3c0 5 4 8 9 8s9-3 9-8v-3c0-5-4-9-9-9zm0 3c2 0 4 1.5 5 4H7c1-2.5 3-4 5-4zm-6 7h12v2H6v-2zm0 4h12c-1 2.5-3 4-6 4s-5-1.5-6-4z" />
    </svg>
);

export const IconSpring = ({ size = 22, color = '#ff8833' }) => (
    <svg {...sz(size, color)}>
        <path d="M4 20h16v2H4v-2zm2-3l3-3-3-3 3-3-3-3h12l-3 3 3 3-3 3 3 3H6z" />
    </svg>
);

export const IconSpeedpad = ({ size = 22, color = '#33aaff' }) => (
    <svg {...sz(size, color)}>
        <path d="M2 12l10-10v6h10v8H12v6L2 12z" />
    </svg>
);

export const IconSpike = ({ size = 22, color = '#ff3344' }) => (
    <svg {...sz(size, color)}>
        <path d="M12 2L4 22h16L12 2z" />
    </svg>
);

export const IconCube = ({ size = 22, color = '#22ff66' }) => (
    <svg {...sz(size, color)}>
        <path d="M3 7l9-5 9 5v10l-9 5-9-5V7zm9-2.5L5.5 8 12 11.5 18.5 8 12 4.5zM5 9.5v7L11 20v-7L5 9.5zm14 0L13 13v7l6-3.5v-7z" />
    </svg>
);

export const IconShip = ({ size = 22, color = '#ff8833' }) => (
    <svg {...sz(size, color)}>
        <path d="M2 14l4-1 2-5h6l3 4 5 1-2 4-3 1H5l-3-4zm5 0c0 1 .8 2 2 2s2-.8 2-2-.8-2-2-2-2 .9-2 2zm9 0c0 1 .8 2 2 2s2-.8 2-2-.8-2-2-2-2 .9-2 2z" />
    </svg>
);

export const IconPartyPopper = ({ size = 22, color = '#ffe44a' }) => (
    <svg {...sz(size, color)}>
        <path d="M3 21l5-13 8 8L3 21zm6-11l5 5-7 3 2-8zm5-7l-1.5 2L16 7l2-1.5L19 7l1-1.5L17 4l-3-1zM21 12l-2 1.5L20.5 16 22 14.5 21 12z" />
    </svg>
);
